<template>
  <div class="videoPlayerContainer">
    <div style="position:absolute;">
      <Media
          :style="{width:'100%', zIndex:'2000'}"
          :kind="'video'"
          :controls="true"
          v-click-outside="clickedOutSideOfVideoPlayer"
          id="instructionVideo"
          :src="videoAddress">
      </Media>
    </div>
  </div>
</template>

<script>
import Media from '@dongido/vue-viaudio'

export default {

  name: "VideoPlayer",
  props: {
    videoAddress: String,
  },
  components: {
    Media: Media,
  },
  methods: {
    clickedOutSideOfVideoPlayer() {
      return this.$emit('closeVideoClickedOutSide');
    },
  }
}
</script>

<style scoped>

.videoPlayerContainer {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center
}

</style>